import ImageButton from './_image-button.js'

export default {
  name: 'ShowAllSelectionsButton',
  values: {
    showAllButton: {
      configSet: ImageButton,
      configValues: {
        button: {
          style: {
            base: {
              minWidth: '100%',
              minHeight: '40px',
              alignSelf: 'center',
              alignItems: 'center',
            },
          },
        },
        buttonIcon: {
          src: 'arrow-down',
          style: {
            minWidth: '16px',
            minHeight: '16px',
          },
        },
        innerContainer: {
          style: {
            flexDirection: 'row',
            flexGrow: 0,
          },
        },
        buttonLabel: {
          container: {
            textAlign: 'center',
            padding: '0 0 0 6px',
            textTransform: 'uppercase',
          },
        },
      },
    },
    hideAllButton: {
      configSet: ImageButton,
      configValues: {
        button: {
          style: {
            base: {
              minWidth: '100%',
              minHeight: '40px',
              alignSelf: 'center',
              alignItems: 'center',
            },
          },
        },
        buttonIcon: {
          src: 'arrow-up',
          style: {
            minWidth: '16px',
            minHeight: '16px',
          },
        },
        innerContainer: {
          style: {
            flexDirection: 'row',
            flexGrow: 0,
          },
        },
        buttonLabel: {
          container: {
            textAlign: 'center',
            padding: '0 0 0 6px',
            textTransform: 'uppercase',
          },
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
